import { ChangeDetectionStrategy, Component, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { filter, take } from 'rxjs/operators';
import { map } from 'rxjs';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DataProtectionNoticeService } from './data-protection-notice.service';
import { DataProtectionNoticeItemFacade } from '../../../store/state/administration/data-protection-notice/item/data-protection-notice-item.facade';
import { DataProtectionNoticeItemFileFacade } from '../../../store/state/administration/data-protection-notice/item-file/data-protection-notice-item-file.facade';
import { AuthFacade } from '../../../store/state/auth/auth.facade';
import { CountryCodes } from '../../constants/countries';
import { Language } from '../../constants/language';

@Component({
  selector: 'lib-data-protection-notice-accept',
  templateUrl: './data-protection-notice-accept.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataProtectionNoticeAcceptComponent implements OnInit {
  isDpnAccepted = false;
  isNewsletterSubscriptionAccepted = false;
  private isChinaContext = false;

  constructor(
    public authFacade: AuthFacade,
    private dpnItemFileFacade: DataProtectionNoticeItemFileFacade,
    private dpnItemFacade: DataProtectionNoticeItemFacade,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private dpnService: DataProtectionNoticeService,
    private activatedRoute: ActivatedRoute,
    @Optional() private dialogRef: MatDialogRef<DataProtectionNoticeAcceptComponent>,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap
      .pipe(
        take(1),
        map((params: ParamMap) => params.get('countryFD') === CountryCodes.CN),
      )
      .subscribe((isChina: boolean) => {
        this.isChinaContext = isChina;
      });
  }

  openDpnText(): void {
    if (this.isChinaContext) {
      window.open('/legal-documents/data-protection-notice/CN', '_blank');
    } else {
      this.authFacade.country$.pipe(filter(Boolean), take(1)).subscribe((country: string) => {
        this.dpnItemFileFacade.getLastDpnItemFile(country);
        this.dpnService.openDpnText(this.dialog);
      });
    }
  }

  acceptDpnItem(): void {
    if (this.isChinaContext) {
      if (this.dialogRef) {
        this.dialogRef.close();
      }
    } else {
      this.dpnItemFacade.acceptDpnItem(
        this.isNewsletterSubscriptionAccepted,
        this.translateService.currentLang.toUpperCase() as Language,
      );
    }
  }
}
